import * as S from "./style.SortTypeSelector";
import React, { useEffect, useMemo, useState } from "react";
import ReactSelect  from "react-select";
import { ISearchBox, TableHeader, CSVHeader, IDropDown } from '../../types/type';
import { useSelector } from 'react-redux';
import { RootState } from '../../modules';




const SorttypeSelector = ({title, options, selected, setSelected }:any) => {

  const langState = useSelector((state:RootState) => state.langReducer);

  const SortType:IDropDown[] =[
    {label : langState.isKor? "오름차순" : "ASCENDING", value:"ASC"},
    {label : langState.isKor? "내림차순" : "DESCENDING", value:"DESC"},
  ]
    
  const handleChange = (newValue:any) => {   
    if(newValue==null){ setSelected([]); return;}
    setSelected([]);
    setSelected((prev:IDropDown[])=>{
      return[...prev,{value : newValue.value, label : newValue.label}]
    })
  };

  const customStyles = {

    valueContainer: (provided:any, state:any) => ({
      ...provided,
      textOverflow: "ellipsis",
      maxWidth: "95%",
      //whiteSpace: "nowrap",
      //overflow: "hidden",
      //display: "initial",
      height: '30px',
      fontSize : '15px'
    }),

    // input: (provided:any, state:any) => ({
    //   ...provided,
    //   margin: '0px',
    // }),

    // indicatorSeparator: (state:any) => ({
    //   display: 'none',
    // }),
    
    // indicatorsContainer: (provided:any, state:any) => ({
    //   ...provided,
    //   height: '30px',
    // }),

    placeholder: (defaultStyles:any) => ({  
        ...defaultStyles,
        fontSize: '13px'
        
    }),

    singleValue: (defaultStyles:any) => ({  
      ...defaultStyles,
      fontSize: '13px'
    }),


    option: (styles:any, { data, isDisabled, isFocused, isSelected }:any) => {
      
      //console.log({ data, isDisabled, isFocused, isSelected });
      return {
        ...styles,
        backgroundColor: isSelected ? "lightgray" : "white",
        color: "#333333",
        fontSize : "13px",
        "&:hover": {                                           // overriding hover
          ...styles,                                          // apply initial styles         
        },
        borderRadius: 5,
      };
    }
  };

  return (
      <S.Container>
        <div className='header'>{title}</div>
        <div className="App">
          <ReactSelect
            //@ts-ignore
            onChange={handleChange}
            options={SortType}
            closeMenuOnSelect={true}
            hideSelectedOptions={false}
            isSearchable={true}
            styles={customStyles}
            isClearable={true}
            theme={(theme) => ({
                ...theme,
                borderRadius: 10,
                colors: {
                  ...theme.colors,
                  primary25: 'lightgray',
                  primary: '#333333',
                },
              })}
          />
        </div>
      </S.Container>
  );


};


export default SorttypeSelector;
